import mod from "-!./AccountForm.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./AccountForm.js?vue&type=script&lang=js&external"